// ============================================================
// Server
// ============================================================

export const SERVER_PORT = 4000;
export const SERVER_TICK_RATE = 30;
export const SERVER_TICK_MS = 1000 / SERVER_TICK_RATE;

// ============================================================
// Players
// ============================================================

export const MAX_PLAYERS = 20;
export const MAX_PER_TEAM = 10;
export const RESPAWN_COOLDOWN_MS = 4000;

// ============================================================
// Drone (Shahed) Stats
// ============================================================

export const DRONE_BASE_SPEED = 80;
export const DRONE_BOOST_MULTIPLIER = 2.4;
export const DRONE_BOOST_DURATION_MS = 3000;
export const DRONE_BOOST_COOLDOWN_MS = 10000;
export const DRONE_FLARE_COOLDOWN_MS = 8000;
export const DRONE_FLARE_DURATION_MS = 1500;
export const DRONE_TURN_RATE = 1.5;
export const DRONE_HITBOX_RADIUS = 3;

// ============================================================
// Fighter (F-16) Stats
// ============================================================

export const FIGHTER_BASE_SPEED = DRONE_BASE_SPEED * 1.5;
export const FIGHTER_TURN_RATE = 2.0;
export const FIGHTER_HITBOX_RADIUS = 4;

// ============================================================
// Weapons
// ============================================================

export const MISSILE_SPEED = 250;
export const MISSILE_TURN_RATE = 3.0;
export const MISSILE_LIFETIME_MS = 6000;
export const MISSILE_LOCK_TIME_MS = 1500;
export const MISSILE_MAX_AMMO = 4;
export const MISSILE_RELOAD_MS = 5000;
export const GUN_DAMAGE = 10;
export const GUN_RANGE = 150;
export const GUN_FIRE_RATE_MS = 100;

// ============================================================
// Map
// ============================================================

export const MAP_RADIUS = 500;
export const DRONE_SPAWN_DISTANCE = 2400;
export const TOWER_POSITION = { x: 0, y: 0, z: 0 } as const; // ship position
export const TOWER_HEIGHT = 50; // ship height
export const TOWER_HITBOX_RADIUS = 40; // ship hitbox

// ============================================================
// Scoring
// ============================================================

export const POINTS_DRONE_REACH_TOWER = 1;
export const POINTS_FIGHTER_KILL_DRONE = 1;

// ============================================================
// Networking
// ============================================================

export const STALE_THRESHOLD_MS = 2000;  // exclude from broadcast after 2s no update
export const STALE_REMOVE_MS = 5000;     // force-remove player after 5s no update
